<template>
  <a-modal
    :visible="visible"
    :title="title"
    :footer="null"
    :width="isStructural ? '560px' : '720px'"
    @cancel="$emit('close')"
  >
    <template v-if="isStructural">
      <a-alert type="error" show-icon>
        <div slot="message" class="import-errors__structural">
          <p v-for="(row, index) in rows" :key="index">{{ row.mensagem }}</p>
        </div>
      </a-alert>

      <div class="import-errors__actions">
        <a-button @click="$emit('close')">Fechar</a-button>
        <a-button type="primary" @click="$emit('download-template')">
          <a-icon type="vertical-align-bottom" /> Baixar template
        </a-button>
      </div>
    </template>

    <template v-else>
      <p class="import-errors__summary">
        {{ summary }}
        <strong v-if="showAtomicityNote">Nada foi gravado.</strong>
      </p>

      <div class="import-errors__table-wrapper">
        <table class="import-errors__table">
          <thead>
            <tr>
              <th class="import-errors__line">Linha</th>
              <th class="import-errors__column">Coluna</th>
              <th>Erro</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="index">
              <td class="import-errors__line">{{ row.linha || "—" }}</td>
              <td class="import-errors__column">{{ row.coluna || "—" }}</td>
              <td>{{ row.mensagem }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="import-errors__actions import-errors__actions--split">
        <a-button type="link" @click="$emit('download-report')">
          <a-icon type="download" /> Baixar relatório
        </a-button>

        <div class="import-errors__actions-group">
          <a-button @click="$emit('close')">Fechar</a-button>
          <a-button type="primary" @click="$emit('retry')">
            Corrigir e reenviar
          </a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
const DEFAULT_TITLE = "Não foi possível importar a planilha";

export default {
  name: "FreightTableImportErrorsModal",
  props: {
    visible: { type: Boolean, default: false },
    error: { type: Object, default: null },
  },
  computed: {
    title() {
      return (this.error && this.error.title) || DEFAULT_TITLE;
    },
    rows() {
      return (this.error && this.error.rows) || [];
    },
    isStructural() {
      return !!this.error && this.error.kind === "structural";
    },
    summary() {
      if (this.error && this.error.message) return this.error.message;

      const total = this.rows.length;

      return total === 1
        ? "Foi encontrado 1 erro na planilha."
        : `Foram encontrados ${total} erros na planilha.`;
    },
    showAtomicityNote() {
      return !/nada foi gravado/i.test(this.summary);
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/shared/styles/variables.less";

.import-errors {
  &__summary {
    // O tema legado força Montserrat em h1..h6 e no corpo; o módulo novo usa Inter.
    font-family: @font-primary;
    margin-bottom: 16px;
  }

  &__structural {
    font-family: @font-primary;

    p {
      margin: 0;

      + p {
        margin-top: 8px;
      }
    }
  }

  &__table-wrapper {
    max-height: 420px;
    overflow: auto;
  }

  &__table {
    width: 100%;
    border-collapse: collapse;
    font-family: @font-primary;
    font-size: 13px;

    th,
    td {
      text-align: left;
      padding: 8px 12px;
      border-bottom: 1px solid #f0f0f0;
      vertical-align: top;
    }

    th {
      position: sticky;
      top: 0;
      background: #fafafa;
      font-weight: 600;
    }
  }

  &__line {
    width: 72px;
    white-space: nowrap;
  }

  &__column {
    width: 220px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    margin-top: 16px;

    &--split {
      justify-content: space-between;
    }
  }

  &__actions-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>
